<card [noHeader]="true">
  <section body class="sales-report-body">
    <div class="sales-report-top-bar">
      <nav class="sales-report-breadcrumbs" aria-label="Breadcrumb">
        <a class="breadcrumb-link" routerLink="/reports">
          {{ 'navigator.links.reports' | translate }}
        </a>
        <span class="breadcrumb-arrow-icon" aria-hidden="true"></span>
        <span class="breadcrumb-current">
          {{ 'cards.reports.sales_report.title' | translate: { retailer: retailerName } }}
        </span>
      </nav>

      <div class="sales-report-selected-stores">
        <span class="selected-stores-label">
          {{ selectionLabelKey | translate }}
        </span>
        <div class="selected-stores-pills">
          <ng-container *ngIf="selectionItems.length; else emptySelection">
            <span class="store-pill" *ngFor="let item of selectionItems">
              {{ item }}
            </span>
          </ng-container>
          <ng-template #emptySelection>
            <span class="store-pill">
              {{ emptySelectionKey | translate }}
            </span>
          </ng-template>
        </div>
      </div>
    </div>

    <sales-report-skeleton
      *ngIf="isLoading; else idleState"
      [retailerName]="retailerName"
      [dateFrom]="dateFrom"
      [dateTo]="dateTo"
    ></sales-report-skeleton>

    <ng-template #idleState>
      <sales-report-products
        *ngIf="isReady; else emptyState"
        [search]="search"
        [retailerName]="retailerName"
        [dateFrom]="dateFrom"
        [dateTo]="dateTo"
        [expiresAt]="expiresAt"
        [isExpired]="isExpired"
        [canManage]="canManage"
        (expand)="expand.emit()"
      ></sales-report-products>

      <ng-template #emptyState>
        <h2 class="sales-report-title">
          {{ 'cards.reports.sales_report.title' | translate: { retailer: retailerName } }}
        </h2>

        <no-content
          image="no-report-data"
          heading="cards.reports.sales_report.no_data_heading"
          text="cards.reports.sales_report.no_data_text"
        ></no-content>
      </ng-template>
    </ng-template>
  </section>
</card>
